module.exports = __webpack_public_path__ + "static/bg03-e3378d60a37538c36564da081e4b8c7e.jpg";